import { IRouteModel } from '~/utils/interface/base';

/**
 * Checks if a menu item has an active child based on the current URL path.
 * @param menuItem The menu item object to check.
 * @param currentPath The current URL pathname.
 * @returns True if the menu item has an active child route, false otherwise.
 */
export const hasActiveChild = (menuItem: IRouteModel, currentPath: string): boolean => {
  const isChildActive = menuItem?.children?.some(
    (childItem: IRouteModel) =>
      childItem.path === currentPath ||
      isSubRoute(childItem.path, currentPath) ||
      hasActiveChild(childItem, currentPath)
  );
  return isChildActive || menuItem.path === currentPath;
};

/**
 * Determines if a given path is a sub-route of the parent path.
 * @param parentRoutePath The parent route path.
 * @param targetPathname The current route path to evaluate.
 * @returns True if the target path is a sub-route of the parent path and not identical to it, false otherwise.
 */
export const isSubRoute = (parentRoutePath: string, targetPathname: string): boolean => {
  return targetPathname.startsWith(parentRoutePath) && targetPathname !== parentRoutePath;
};
